<template>
  <div ref="el" :style="{ width: '100%', height: height + 'px' }"></div>
</template>

<script>
import * as echarts from 'echarts'
import { buildChartOption } from './rbUtil'

export default {
  name: 'RbChart',
  props: {
    section: { type: Object, required: true },
    rows: { type: Array, default: () => [] },
    height: { type: Number, default: 320 }
  },
  data () {
    return { chart: null }
  },
  mounted () {
    this.chart = echarts.init(this.$refs.el)
    this.render()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
    if (this.chart) this.chart.dispose()
  },
  watch: {
    rows () { this.render() },
    section: { deep: true, handler () { this.render() } }
  },
  methods: {
    render () {
      if (!this.chart) return
      this.chart.setOption(buildChartOption(this.section, this.rows), true)
    },
    resize () {
      if (this.chart) this.chart.resize()
    },
    // used by print: a white-background PNG of the current chart
    getImage () {
      return this.chart ? this.chart.getDataURL({ pixelRatio: 2, backgroundColor: '#fff' }) : null
    }
  }
}
</script>
